import React from "react";

function AttestationTypeList(props) {
    const { t } = props;

    return (
        <>

            <div class="accordion accordion-flush" id="attestationType">
                {
                    props.paAttestationTypesList.length>0 &&
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingOne">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t('INDIVIDUAL_AFFAIRS_DOCUMENTS')}
                            </button>
                        </h2>
                        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#attestationType">
                            <div class="accordion-body attestation-list">
                                {
                                    props.paAttestationTypesList.map((item) => {
                                        return (
                                            <li> {props.language === "en" ? item.nameEn : item.nameAr}</li>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    props.caAttestationTypesList.length>0 &&
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                {t('COMMERCIAL_DOCUMENTS')}
                            </button>
                        </h2>
                        <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#attestationType">
                            <div class="accordion-body attestation-list">
                                {
                                    props.caAttestationTypesList.map((item) => {
                                        return (
                                            <li> {props.language === "en" ? item.nameEn : item.nameAr}</li>

                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    );

}
export default AttestationTypeList;